function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-music",
  "data-name": "Icon awesome-music",
  d: "M21,1.313A1.312,1.312,0,0,0,19.293.061L6.169,3.937A1.312,1.312,0,0,0,5.25,5.188V15.91a5.674,5.674,0,0,0-1.312-.161C1.763,15.749,0,16.925,0,18.374S1.763,21,3.937,21s3.937-1.175,3.937-2.625V8.79l10.5-3.077v7.573a5.674,5.674,0,0,0-1.312-.161c-2.175,0-3.937,1.175-3.937,2.625s1.763,2.625,3.937,2.625S21,17.2,21,15.749V1.313Z",
  transform: "translate(0 0.001)",
  fill: "#4853ec"
});

var SvgIconawesomeMusic = function SvgIconawesomeMusic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconawesomeMusic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon awesome-music.faf227bd.svg";
export { ForwardRef as ReactComponent };